import { render } from "./CustomerTable.vue?vue&type=template&id=cfaae2e2&scoped=true&ts=true&lang=pug"
import script from "./CustomerTable.vue?vue&type=script&lang=ts"
export * from "./CustomerTable.vue?vue&type=script&lang=ts"

import "./CustomerTable.vue?vue&type=style&index=0&id=cfaae2e2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfaae2e2"]])

export default __exports__